module.exports = __webpack_public_path__ + "img/button_double_chevron_left.0fa28636.svg";